






































import {Component, Mixins} from "vue-property-decorator";
import NumberGenerator from "@/common/mixins/numberGenerator";
import historyApi from "@/api/historyApi";
import History from "@/model/history";

@Component({
  name: "orderChecking",
  components: {},
})

export default class OrderChecking extends Mixins(NumberGenerator){
  public historyList: History[] = null;
  public totalPrice = 0;
  public totalQuantity = 0;
  public customerNumber = 1;
  public price = 0;

  async mounted() {
    this.historyList = await historyApi.index()
    this.getTotalQuantity()
    this.getTotalPrice()
    this.price = this.totalPrice
  }

  public addCustomerNumber() {
    this.customerNumber++
    this.price = Number.parseInt((this.totalPrice / this.customerNumber).toFixed(0))
  }

  public subCustomerNumber() {
    if (this.customerNumber > 0) {
      this.customerNumber--;
      this.price = Number.parseInt((this.totalPrice / this.customerNumber).toFixed(0))
    }
  }

  public isDisableByCustomerNumber() {
    return this.customerNumber === 1;
  }

  public priceEachCustomer() {
    return this.customerNumber === 0;
  }

  private async getTotalQuantity() {
    this.historyList.map(value => {
      this.totalQuantity += value.quantity
    });
  }

  private async getTotalPrice() {
    this.historyList.map(value => {
      this.totalPrice += value.rowTotalPrice
    });
  }
}
